<template>
  <PageTemplate title="Contato">
    <v-row justify="center">
      <v-col cols="12" md="7" lg="6">
        <ContactForm
          :action="files + formAction"
          response-to="/contato/obrigado"
        />
      </v-col>
    </v-row>
  </PageTemplate>
</template>

<script>
import PageTemplate from "../components/templates/PageTemplate.vue";
import ContactForm from "../components/forms/ContactForm.vue";

export default {
  data: () => ({
    formAction: "/rest/email/contact-us",
  }),
  components: {
    PageTemplate,
    ContactForm,
  },
};
</script>
